import React from "react"
import {Badge, Tab, type TabProps} from "@mui/material"
import {useLocation, useNavigate} from "react-router-dom"
import styled from "styled-components"

import {useCustomerID} from "../useCustomerID"

import {offerStatusColors} from "./offerStatusColors"

import {useOfferStatus} from "@indebted/api/customerOffersAPI"

function OffersTab(props: TabProps) {
	const customerID = useCustomerID()
	const location = useLocation()
	const navigate = useNavigate()
	const isActive = location.pathname.endsWith("/offers")
	const offerStatus = useOfferStatus(customerID)
	const showBadge = offerStatus === "available" || offerStatus === "upcoming"

	return (
		<StyledTab
			{...props}
			label={
				<Badge
					variant="dot"
					invisible={isActive || !showBadge}
					sx={{"& .MuiBadge-dot": {right: -8, backgroundColor: offerStatusColors(offerStatus)}}}
				>
					Offers
				</Badge>
			}
			onClick={() => navigate(`/customers/${customerID}/offers${location.search}`)}
		/>
	)
}

const StyledTab = styled(Tab)`
	min-width: auto;
	max-width: auto;
	padding: 6px 12px;
`

OffersTab.muiName = "Tab"

export {OffersTab}
